import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./PortfolioTeaser.css";

const AUTO_ADVANCE_MS = 5000;

const slides = [
	{
		src:
			process.env.PUBLIC_URL +
			"/images-v2/portfolio/communie/eerste-communie-2026/1.webp",
		alt: "Verlichte letters Eerste Communie",
	},
	{
		src: process.env.PUBLIC_URL + "/images-v2/homepage/1.webp",
		alt: "Verlichte letters LOVE BOAT op een feest",
	},
	{
		src: process.env.PUBLIC_URL + "/images-v2/homepage/2.webp",
		alt: "Verlichte letters JUNGLE met apen en palmbomen in de tuin",
	},
];

function PortfolioTeaser() {
	const [current, setCurrent] = useState(0);
	const [isPaused, setIsPaused] = useState(false);
	// Bumped on manual navigation so the timer restarts from a full interval.
	const [timerEpoch, setTimerEpoch] = useState(0);

	// Auto-advance one slide at a time; paused while hovering, skipped
	// entirely for reduced-motion users (they keep manual dot navigation).
	useEffect(() => {
		if (isPaused || slides.length <= 1) return;
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
		const id = setInterval(() => {
			setCurrent((c) => (c + 1) % slides.length);
		}, AUTO_ADVANCE_MS);
		return () => clearInterval(id);
	}, [isPaused, timerEpoch]);

	return (
		<section className="portfolio-teaser-section">
			<div
				className="portfolio-teaser-header stagger-item"
				style={{ "--stagger-index": 0 }}>
				<span className="portfolio-teaser-eyebrow">03 — Portfolio</span>
				<h2 className="portfolio-teaser-title">Recente evenementen</h2>
				<p className="portfolio-teaser-intro">
					Een glimp van de feesten die wij mochten aankleden.
				</p>
			</div>

			<div
				className="portfolio-teaser-carousel stagger-item"
				style={{ "--stagger-index": 1 }}
				onMouseEnter={() => setIsPaused(true)}
				onMouseLeave={() => setIsPaused(false)}
				aria-roledescription="carousel"
				aria-label="Recente evenementen">
				<div className="portfolio-teaser-frame">
					<div className="portfolio-teaser-imagewrap">
						{slides.map((slide, i) => (
							<img
								key={i}
								src={slide.src}
								alt={slide.alt}
								loading={i === 0 ? "eager" : "lazy"}
								aria-hidden={i === current ? undefined : "true"}
								className={`portfolio-teaser-slide${
									i === current ? " is-active" : ""
								}`}
							/>
						))}
					</div>
				</div>

				<div
					className="portfolio-teaser-dots"
					role="tablist"
					aria-label="Evenementen">
					{slides.map((slide, i) => (
						<button
							key={i}
							type="button"
							role="tab"
							className={`portfolio-teaser-dot${
								i === current ? " active" : ""
							}`}
							aria-label={slide.alt}
							aria-selected={i === current ? "true" : "false"}
							onClick={() => {
								setCurrent(i);
								setTimerEpoch((e) => e + 1);
							}}
						/>
					))}
				</div>
			</div>

			<div
				className="portfolio-teaser-cta stagger-item"
				style={{ "--stagger-index": 4 }}>
				<Link to="/portfolio" className="portfolio-teaser-link">
					Bekijk portfolio{" "}
					<span className="portfolio-teaser-arrow">→</span>
				</Link>
			</div>
		</section>
	);
}

export default PortfolioTeaser;
